var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _g2, _path8, _g3, _path9, _g4, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartner1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 58,
    viewBox: "0 0 230 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0996 0H4.176C1.86992 0 0 1.86992 0 4.176V26.1001H26.0996V0ZM0 53.824V31.9001H26.0996V58H4.176C1.86992 58 0 56.1301 0 53.824ZM53.824 58H31.8996V31.9001H58V53.824C58 56.1301 56.1301 58 53.824 58ZM19.6265 10.2002C20.5452 7.90341 20.979 7.67373 22.6889 7.44405V6.72949H16.8193V7.44405C18.9119 7.69925 19.2182 7.92893 18.6567 9.40909C17.4573 12.6246 15.773 16.7844 14.4204 20.0765C12.8127 15.8401 10.9497 10.7617 10.3117 8.89869C9.95441 7.95445 10.0565 7.64821 11.945 7.44405V6.72949H5.46289V7.44405C7.01961 7.59717 7.45345 7.85237 8.16801 9.74085C9.62265 13.5178 11.8174 19.4895 13.3231 23.5982H14.1652C15.1819 21.0254 17.7 14.893 18.9763 11.7847L18.9766 11.7841L18.9767 11.7837L18.9794 11.7772C19.2714 11.0661 19.4981 10.514 19.6265 10.2002ZM10.5977 52.2941V51.5795C12.6903 51.3498 12.8945 51.2477 12.8945 49.0785V38.9471C12.8945 36.7524 12.6903 36.6503 10.5977 36.4206V35.7061H17.4359V36.4206C15.3177 36.6503 15.1135 36.7524 15.1135 38.9471V49.0785C15.1135 51.2733 15.3177 51.3498 17.4359 51.5795V52.2941H10.5977ZM50.213 52.052C50.5958 51.2609 51.2593 49.4235 51.6166 48.1985V48.1973L50.851 47.9421C49.5494 50.4941 48.299 51.6936 45.6959 51.6936C41.8169 51.6936 38.9842 48.5303 38.9842 43.6049C38.9842 39.7003 41.2044 36.2807 45.4918 36.2807C46.4615 36.2807 47.3802 36.4083 48.0438 36.7145C49.3453 37.2504 50.0088 38.3733 50.5192 40.0831L51.3103 39.9045C51.1062 38.6285 50.9275 37.0718 50.8254 35.9234C50.5931 35.8952 50.2909 35.8379 49.9311 35.7697C48.9866 35.5907 47.6452 35.3364 46.1298 35.3364C40.3622 35.3364 36.3301 38.6795 36.3301 44.1408C36.3301 48.4537 39.4435 52.6645 45.5428 52.6645C47.1231 52.6645 48.7372 52.3426 49.6813 52.1544C49.8959 52.1116 50.0759 52.0757 50.213 52.052Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1787 17.4048L33.6544 18.7388H34.224V19.117H32.8633V18.7388H33.1962L35.3294 13.3135H35.7853L37.9174 18.7388H38.2492V19.117H36.53V18.7388H37.0509L36.5254 17.4048H34.1799H34.1787ZM34.3272 17.0266H36.3746L35.3503 14.4213L34.3272 17.0266Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1538 16.5985V18.7387H40.7246V19.1169H38.7734V18.7387H39.3442V13.7878H38.7734V13.4097H40.7976C41.4403 13.4097 41.9217 13.5291 42.2418 13.7669C42.562 14.0047 42.7221 14.3632 42.7221 14.8423C42.7221 15.2309 42.6235 15.558 42.4251 15.8236C42.2268 16.0893 41.9298 16.2923 41.5342 16.4338L43.0573 18.7375H43.4819V19.1157H42.2998L40.7373 16.5985H40.155H40.1538ZM40.1538 16.2203H40.3963C40.887 16.2203 41.2547 16.1078 41.4994 15.8816C41.743 15.6566 41.866 15.319 41.866 14.8701C41.866 14.4548 41.7558 14.1706 41.5342 14.0175C41.3127 13.8644 40.9009 13.7878 40.2965 13.7878H40.1538V16.2203Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0296 13.8377H44.387V14.5012H43.959V13.4097H48.9099V14.5012H48.4818V13.8377H46.8393V18.7387H47.41V19.1169H45.4589V18.7387H46.0296V13.8377Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0117 18.9266C52.528 19.1169 52.0849 19.212 51.6812 19.212C51.0699 19.212 50.5722 19.0044 50.1894 18.5891C49.8066 18.1738 49.6152 17.6367 49.6152 16.9778C49.6152 16.319 49.7869 15.8329 50.1314 15.4327C50.476 15.0325 50.9179 14.833 51.4573 14.833C51.9561 14.833 52.3401 15.0012 52.608 15.3376C52.8772 15.674 53.0106 16.1566 53.0106 16.783V16.9256H50.4191C50.4191 17.4766 50.5398 17.9082 50.7822 18.2202C51.0246 18.5322 51.3599 18.6877 51.7902 18.6877C52.2206 18.6877 52.6115 18.5775 53.0106 18.3559V18.9266H53.0117ZM50.4702 16.544H52.2055V16.4477C52.2055 15.623 51.9422 15.21 51.4156 15.21C51.1279 15.21 50.9052 15.3214 50.7486 15.5429C50.592 15.7645 50.4992 16.0986 50.4713 16.544H50.4702Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1103_1176",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 10,
    width: 3,
    height: 2
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8098 11.2108C34.7924 11.5959 35.0905 11.9218 35.4756 11.9381C35.8607 11.9555 36.1867 11.6574 36.2029 11.2722C36.2192 10.8871 35.921 10.5612 35.5359 10.5449C35.5255 10.5449 35.515 10.5449 35.5046 10.5449C35.1334 10.5449 34.8248 10.8372 34.8086 11.2119",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1103_1176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.7972 10.4828L34.7324 11.9546L36.2193 12.02L36.284 10.5483L34.7972 10.4828Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1103_1176",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 10,
    width: 2,
    height: 2
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.007 11.2108C39.9896 11.5959 40.2877 11.9218 40.6729 11.9381C41.058 11.9555 41.3839 11.6574 41.4002 11.2722C41.4164 10.8871 41.1183 10.5612 40.7332 10.5449C40.7227 10.5449 40.7123 10.5449 40.7019 10.5449C40.3307 10.5449 40.0221 10.8372 40.0059 11.2119",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1103_1176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9945 10.4828L39.9297 11.9546L41.4165 12.02L41.4813 10.5483L39.9945 10.4828Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1103_1176",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 10,
    width: 2,
    height: 2
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5574 11.2108C45.54 11.5959 45.8392 11.9218 46.2244 11.9381C46.6095 11.9555 46.9354 11.6574 46.9517 11.2722C46.9691 10.8871 46.671 10.5612 46.2858 10.5449C46.2754 10.5449 46.265 10.5449 46.2545 10.5449C45.8833 10.5449 45.5748 10.8372 45.5574 11.2119",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1103_1176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.5452 10.4828L45.4805 11.9546L46.9673 12.02L47.0321 10.5483L45.5452 10.4828Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1103_1176",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 10,
    width: 1,
    height: 2
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0784 10.7848C39.0724 10.9176 39.1752 11.03 39.308 11.0356C39.4408 11.0412 39.5532 10.9388 39.5588 10.806C39.5648 10.6732 39.4616 10.5608 39.3292 10.5552C39.3256 10.5552 39.322 10.5552 39.3184 10.5552C39.1904 10.5552 39.084 10.656 39.0784 10.7852",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1103_1176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.0731 10.5335L39.0508 11.041L39.5635 11.0636L39.5858 10.5561L39.0731 10.5335Z",
    fill: "white"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M219.577 43.5026C213.096 43.5026 209.145 39.2597 209.145 32.6422C209.145 26.1026 213.175 21.665 219.3 21.665C224.556 21.665 229.1 24.8959 229.1 32.3308V33.8879H214.123C214.183 37.4885 216.336 39.61 219.616 39.61C221.829 39.61 223.331 38.6758 223.963 37.4301H228.902C227.993 41.0892 224.556 43.5026 219.577 43.5026ZM214.163 30.5013H224.279C224.239 27.6207 222.303 25.5187 219.379 25.5187C216.336 25.5187 214.321 27.7959 214.163 30.5013Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M206.419 21.9334V25.7482H202.191V36.7254C202.191 38.7496 203.218 39.1777 204.482 39.1777C205.075 39.1777 206.063 39.1388 206.695 39.0999V43.1482C206.103 43.265 205.115 43.3428 203.85 43.3428C200.057 43.3428 197.133 41.5133 197.172 37.5428V25.7482H194.09V21.9334H197.172V16.873H202.191V21.9334H206.419Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M179.271 43.0738V21.9369H184.171V25.4403H184.409C185.159 23.0268 187.254 21.6255 189.704 21.6255C190.257 21.6255 191.047 21.6644 191.521 21.7423V26.3356C191.087 26.1799 190.02 26.0241 189.19 26.0241C186.384 26.0241 184.329 27.9315 184.329 30.6174V43.0738H179.271Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M155.088 43.0732H149.596L159.672 14.8906H165.995L176.111 43.0732H170.618L168.247 36.1054H157.459L155.088 43.0732ZM158.842 32.0181H166.864L162.952 20.6517H162.715L158.842 32.0181Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M144.656 33.7704C142.957 33.7704 141.574 32.408 141.574 30.7341C141.574 29.0992 142.957 27.7368 144.656 27.7368C146.277 27.7368 147.699 29.0992 147.699 30.7341C147.699 32.408 146.277 33.7704 144.656 33.7704Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M132.169 24.3872C131.576 21.0007 128.81 19.0544 125.332 19.0544C120.63 19.0544 117.35 22.5966 117.35 28.9805C117.35 35.4423 120.67 38.9067 125.332 38.9067C128.731 38.9067 131.497 37.0383 132.169 33.7295H137.345C136.555 39.1403 132.05 43.4611 125.253 43.4611C117.706 43.4611 112.174 38.0503 112.174 28.9805C112.174 19.8718 117.785 14.5 125.253 14.5C131.576 14.5 136.476 18.1201 137.345 24.3872H132.169Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M107.551 14.8906V43.0732H102.414V14.8906H107.551Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1507 14.8906L85.5796 37.1175H85.8958L93.3642 14.8906H99.0149L88.8989 43.0732H82.5765L72.5 14.8906H78.1507Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner1);
export default __webpack_public_path__ + "static/media/partner1.9436edb38b19e917c00a7f0d4faff679.svg";
export { ForwardRef as ReactComponent };